import React, { useState } from "react";
import { m as motion } from "../../shared/components/Motion";
import "./work.css";
import Works from "./Works";
import {
  containerVariantsSlow as containerVariants,
  childVariantsSlow as childVariants,
} from "../../shared/utils";

const Work = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <motion.section
      className="work section"
      id="projects"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {isLoading ? (
        <>
          <div className="work__section-title-skeleton" />
          <div className="work__section-subtitle-skeleton" />
        </>
      ) : (
        <>
          <motion.h2 className="section__title" variants={childVariants}>
            Projects
          </motion.h2>
          <motion.span className="section__subtitle" variants={childVariants}>
            Most recent works
          </motion.span>
        </>
      )}

      <motion.div variants={childVariants}>
        <Works onLoadingChange={setIsLoading} />
      </motion.div>
    </motion.section>
  );
};

export default Work;
